import styled from 'styled-components';

export const LoadingStyle = styled.div`
    overflow:hidden;

    .loading{
        width: 300px;
        height: 100px;
        margin:300px auto 0;
    }
    .loading span{
        display: inline-block;
        width: 50px;
        height: 50px;
        margin-right: 5px;
        background: lightgreen;
        transform-origin: right bottom;
        animation: load 1s ease infinite;
    }
    .loading span:last-child{
        margin-right: 0px; 
    }

    @keyframes load{
        0%{
            opacity: 1;
        }
        100%{
            opacity: 0;
            transform: rotate(90deg);
        }
    }
    .loading span:nth-child(1){
        animation-delay:0.13s;
    }
    .loading span:nth-child(2){
        animation-delay:0.26s;
    }
    .loading span:nth-child(3){
        animation-delay:0.39s;
    }
    .loading span:nth-child(4){
        animation-delay:0.52s;
    }
    .loading span:nth-child(5){
        animation-delay:0.65s;
    }

`